module.exports = __webpack_public_path__ + "static/media/me.ca03c5c8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/me.png
 ** module id = 238
 ** module chunks = 0
 **/